import { Component, HostBinding } from '@angular/core';

import { MarqueeConfig } from '@frontend/sports/common/client-config-data-access';
import { times } from 'lodash-es';

@Component({
    selector: 'ms-ghost-loader',
    templateUrl: 'ghost-loader.component.html',
    standalone: false,
})
export class GhostLoaderComponent {
    static readonly MIN_TILES = 5;
    @HostBinding('class') className = 'ghost-loader-container cards';
    items: number[];

    constructor(marqueeConfig: MarqueeConfig) {
        const count = Math.min(GhostLoaderComponent.MIN_TILES, marqueeConfig.maxTiles);
        this.items = times(count);
    }
}
